'use strict';

var _ = require('underscore');

module.exports = function(prevObj, newObj, keys) {
	prevObj = prevObj || {};
	newObj = newObj || {};

	var added = {};
	var changed = {};
	var removed = {};

	var prevKeys = _(prevObj).keys();
	var newKeys = _(newObj).keys();

	if (keys) {
		prevKeys = _(prevKeys).intersection(keys);
		newKeys = _(newKeys).intersection(keys);
	}

	_(newKeys).chain().difference(prevKeys).each(function(key) {
		added[key] = newObj[key];
	});

	_(prevKeys).chain().difference(newKeys).each(function(key) {
		removed[key] = prevObj[key];
	});

	_(newKeys).chain().intersection(prevKeys).each(function(key) {
		var prevValue = prevObj[key];
		var value = newObj[key];
		if (!_.isEqual(prevValue, value)) {
			changed[key] = {prevValue: prevValue, value: value};
		}
	});

	var diff = {};

	if (!_.isEmpty(added)) {
		diff.added = added;
	}

	if (!_.isEmpty(changed)) {
		diff.changed = changed;
	}

	if (!_.isEmpty(removed)) {
		diff.removed = removed;
	}

	return diff;
};
